import { useToast } from '@lifebit-ai/lds'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { approveImportRequest } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import type { ApiErrorResponse } from 'services/types'

interface UseApproveImportRequestParams {
  onSuccess?: () => void
  requestId: string
}

export const useApproveImportRequest = ({ onSuccess, requestId }: UseApproveImportRequestParams) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<void, ApiErrorResponse, void>({
    mutationFn: () => approveImportRequest(requestId),
    onSuccess: () => {
      toast({ message: 'Import request approved successfully' })
      queryClient.invalidateQueries({ queryKey: ImportRequestQueryKeys.Verification(requestId) })
      queryClient.invalidateQueries({ queryKey: ImportRequestQueryKeys.All() })
      invalidateRequestActivityQueries(queryClient)
      onSuccess?.()
    },
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to approve import request') })
    }
  })
}
